import { render, staticRenderFns } from "./InfoCircle.vue?vue&type=template&id=52fe578b"
import script from "./InfoCircle.vue?vue&type=script&lang=js"
export * from "./InfoCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports